const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the filtered content search bar directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('peoplesearchButton', [ function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        hmenu: "=?"
      },
      template: require('../../templates/directives/peoplesearch-button.html'),
      controller: ['$scope', function($scope) {
          var self = this;
        }],
      controllerAs: 'button'
    };
  }]);